import React from 'react';
import ReactDOM from 'react-dom';

import { initKeycloak } from "./util/keycloak";

import { LoadingProvider } from './contexts/LoadingContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import { AplicacaoProvider } from './contexts/AplicacaoContext';
import { UsuarioProvider } from './contexts/UsuarioContext';
import { AuditoriaProvider } from './contexts/AuditoriaContext';
import { DividasEmAbertoProvider } from './contexts/DividasEmAbertoContext';
import App from './components/App';

function renderApp () {
  ReactDOM.render(
    <AplicacaoProvider>
      <UsuarioProvider>
        <AuditoriaProvider>
          <LoadingProvider>
            <SnackbarProvider>
              <DividasEmAbertoProvider>
                <App />
              </DividasEmAbertoProvider>
            </SnackbarProvider>
          </LoadingProvider>
        </AuditoriaProvider>
      </UsuarioProvider>
    </AplicacaoProvider>,
    document.getElementById('root')
  );
}

initKeycloak()
.then(renderApp)
  .catch(err => {
    console.error("Erro ao inicializar a aplicação:", err);
  });
